/* eslint-disable */
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import { getAddressFieldsDataView } from "@insite/client-framework/Store/Data/AddressFields/AddressFieldsSelector";
import loadAddressFields from "@insite/client-framework/Store/Data/AddressFields/Handlers/LoadAddressFields";
import { getCartState, getCurrentCartState, isCartLoadedWithLines, isCartLoadedWithoutLines } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import loadCurrentCountries from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import loadCurrentPromotions from "@insite/client-framework/Store/Data/Promotions/Handlers/LoadCurrentPromotions";
import loadPromotions from "@insite/client-framework/Store/Data/Promotions/Handlers/LoadPromotions";
import { getCurrentPromotionsDataView, getPromotionsDataView } from "@insite/client-framework/Store/Data/Promotions/PromotionsSelectors";
import { chain, PreloadData, WaitForData } from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/PreloadCheckoutShippingData";


export type HandlerType = Parameters<typeof PreloadData>[0];

function AuerPreloadData(props: HandlerType) {
    const state = props.getState();
    if (!getCurrentCountries(state)) {
        props.dispatch(loadCurrentCountries());
    }
    if (!getAddressFieldsDataView(state).value) {
        props.dispatch(loadAddressFields());
    }
    if (props.parameter.cartId) {
        const cartState = getCartState(state, props.parameter.cartId);
        if (!isCartLoadedWithLines(cartState)) {
            props.dispatch(loadCart({ cartId: props.parameter.cartId }));
        }
        const promotionsState = getPromotionsDataView(state, props.parameter.cartId);
        if (!promotionsState.value && !promotionsState.isLoading) {
            props.dispatch(loadPromotions({ cartId: props.parameter.cartId }));
        }
    } else {
        const currentCartState = getCurrentCartState(state);
        if (!isCartLoadedWithLines(currentCartState)) {
            //AST-677
            props.dispatch(loadCurrentCart({getCartLines: true}));
        }
        const currentPromotionsState = getCurrentPromotionsDataView(state);
        if (!currentPromotionsState.value && !currentPromotionsState.isLoading) {
            props.dispatch(loadCurrentPromotions());
        }
    }
};

async function AuerWaitForData(props: HandlerType) {
    const checkData = () => {
        const state = props.getState();
        if (!getCurrentCountries(state)) {
            return false;
        }
        if (!getAddressFieldsDataView(state).value) {
            return false;
        }
        if (props.parameter.cartId) {
            const promotions = getPromotionsDataView(state, props.parameter.cartId);
            if (!promotions || promotions.isLoading) {
                return false;
            }
            const cartState = getCartState(state, props.parameter.cartId);
            if (!isCartLoadedWithLines(cartState)) {
                if (isCartLoadedWithoutLines(cartState)) {
                    props.dispatch(loadCart({ cartId: props.parameter.cartId }));
                }
                return false;
            }
        } else {
            const currentPromotions = getCurrentPromotionsDataView(state);
            if (!currentPromotions || currentPromotions.isLoading) {
                return false;
            }
            const currentCartState = getCurrentCartState(state);
            if (!isCartLoadedWithLines(currentCartState)) {
                if (isCartLoadedWithoutLines(currentCartState)) {
                    // AST-677
                    props.dispatch(loadCurrentCart({getCartLines: true}));
                }
                return false;
            }
        }

        return true;
    };

    await waitFor(checkData);
};

replaceInChain(chain, PreloadData, AuerPreloadData);
replaceInChain(chain, WaitForData, AuerWaitForData);
